import * as iconsCSS from './icons.scss';
import type from './type';

const icons = __NATIVE__ ? iconsCSS : iconsCSS.default;
const names = Object.keys(icons).filter(
  icon => typeof icons[icon] === 'string'
);
const normalizedIcons = names.map(
  icon => `\\e${icons[icon].replace(/\"/gi, '')}`
);

export default {
  icons: normalizedIcons,
  type,
  names
};
